module.exports = __webpack_public_path__ + "img/envtemperature.9c31baea.svg";